export const objectMap = (obj, fn) =>
	Object.fromEntries(
		Object.entries(obj).map(([k, v]) => fn([k, v]) || [k, v])
	);

export const objectValuesMap = (obj, fn) =>
	objectMap(obj, ([k, v]) => [k, fn(v, k)]);

export const objectFilter = (obj, fn) =>
	Object.fromEntries(Object.entries(obj).filter(([k, v]) => fn([k, v])));
